export enum InvoiceSource {
    Rapidparts = "Rapidparts",
    Mcfa = "Mcfa",
    Both = "Both",
    Mcfe = "Mcfe",
    Mcfs = "Mcfs",
}
